<mat-form-field class="w-full min-h-[3em] label-grey">
    <mat-label *ngIf="label" class="color-box">{{label | translate}}</mat-label>
    <input (click)="filter()" type=" text" aria-label="auto" placeholder="{{placeholder | translate}}" matInput [matAutocomplete]="auto" [required]="required" [(ngModel)]="this.ngModel" (ngModelChange)="filterChange($event); this.ngModelChange.emit($event)" (focus)="onFocus()" [name]="name">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" multiple [displayWith]="displayWith" ngDefaultControl>
        @for (option of filteredOptions; track option) {
            <mat-option [value]="option"> {{ getLabel(option) }} </mat-option>
        }
    </mat-autocomplete>
    <mat-error> {{error | translate}} </mat-error>
    <mat-icon matSuffix> keyboard_arrow_down </mat-icon>
</mat-form-field>